import { useTranslation } from "react-i18next";
import { Button, Col, DatePicker, Form, FormInstance, Row, Typography } from "antd";
import { FunctionComponent } from "react";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { useForm } from "antd/es/form/Form";
import { get } from "lodash";
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";

type FormFilterProps = {
  showFilter?: boolean;
  clearFilter: (form: FormInstance) => void;
  onFinish?: any;
  dataOptions?: any;
  typeQuestion?: boolean
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  onFinish,
  showFilter,
  clearFilter,
  dataOptions,
  typeQuestion
}) => {
  const { t } = useTranslation();
  const [form] = useForm();

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
      <Form name="filterForm" onFinish={onFinish} form={form}>
          <Row gutter={[{xs: 8, xl: 24, md: 16}, 12]}>
            {!typeQuestion ? 
            <>
            <Col xl={{span: 5}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Phân cấp", "Phân cấp")}</Typography.Title>
              <Form.Item name="level">
                <FormItemDropdown modeDropdown="multiple" placeholder={t("Chọn phân cấp", "Chọn phân cấp")} options={get(dataOptions, 'dataLevel')}/>
              </Form.Item>
            </Col>
            <Col xl={{span: 5}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Tác giả", "Tác giả")}</Typography.Title>
              <Form.Item name="author">
                <FormItemDropdown modeDropdown="multiple" placeholder={t("Chọn tác giả", "Chọn tác giả")} options={get(dataOptions, 'dataAuthor')}/>
              </Form.Item>
            </Col>
            <Col xl={{span: 5}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Phân loại", "Phân loại")}</Typography.Title>
              <Form.Item name="type">
                <FormItemDropdown placeholder={t("Chọn phân loại", "Chọn phân loại")} options={get(dataOptions, 'dataType')}/>
              </Form.Item>
            </Col>
            </> 
              : 
            <>
            <Col xl={{span: 4}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Phân cấp", "Phân cấp")}</Typography.Title>
              <Form.Item name="level">
                <FormItemDropdown modeDropdown="multiple" placeholder={t("Chọn phân cấp", "Chọn phân cấp")} options={get(dataOptions, 'dataLevel')}/>
              </Form.Item>
            </Col>
            <Col xl={{span: 4}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Phân loại", "Phân loại")}</Typography.Title>
              <Form.Item name="type">
                <FormItemDropdown placeholder={t("Chọn phân loại", "Chọn phân loại")} options={get(dataOptions, 'dataType')}/>
              </Form.Item>
            </Col>
            <Col xl={{span: 4}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
            <Typography.Title level={5}>{t("Tác giả", "Tác giả")}</Typography.Title>
              <Form.Item name="author">
                <FormItemDropdown modeDropdown="multiple" placeholder={t("Chọn tác giả", "Chọn tác giả")} options={get(dataOptions, 'dataAuthor')}/>
              </Form.Item>
            </Col>
            <Col xl={{span: 4}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Kết quả duyệt", "Kết quả duyệt")}</Typography.Title>
              <Form.Item name="approved">
                <FormItemDropdown placeholder={t("Chọn kết quả duyệt", "Chọn kết quả duyệt")} options={get(dataOptions, 'dataApproved')}/>
              </Form.Item>
            </Col>
            </>}
            <Col xl={{span: 4}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Thời gian", "Thời gian")}</Typography.Title>
              <Form.Item name="time">
                <DatePicker.RangePicker allowEmpty={[true, true]} placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]} format='DD/MM/YYYY' />
              </Form.Item>
            </Col>
            <Col xl={{span: 3}} md={{span: 9}} sm={{span: 9}} xs={{span: 24}} className="flex align-end">
              <div className="group-btn--filter">
                <Button className="btn btn-primary filter-btn" htmlType="submit">
                  <FilterOutlined/>
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button className="btn btn-outlined clear-filter-btn" onClick={() => clearFilter(form)}>
                  <DeleteOutlined/>
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;